import { FunctionComponent } from 'react'

import styled from 'styled-components'

import config from '@config'
import useBlickPlusOnboardingCurrentStep from '@hooks/useBlickPlusOnboardingCurrentStep'
import useBlickPlusOnboardingTracking from '@hooks/useBlickPlusOnboardingTracking'
import useIsAuthResolved from '@hooks/useIsAuthResolved'
import useUser from '@hooks/useUser'
import useViewportTracking from '@hooks/useViewportTracking'
import EmbeddedContent from '@components/EmbeddedContent'

const {
  blickPlusOnboarding: { onboardingUrl },
} = config

const Wrapper = styled.div``

const NewsletterPage: FunctionComponent = () => {
  const user = useUser()
  const isAuthResolved = useIsAuthResolved()
  const currentStepIndex = useBlickPlusOnboardingCurrentStep()
  const { trackOnImpression } = useBlickPlusOnboardingTracking()

  const viewportRef = useViewportTracking({
    onImpression: trackOnImpression,
    track: true,
  })

  return isAuthResolved && user ? (
    <Wrapper ref={viewportRef}>
      <EmbeddedContent
        url={`${onboardingUrl}?email=${user.email}&hash=${user.s.blick}&element=onboarding&step=${currentStepIndex + 1}`}
      />
    </Wrapper>
  ) : null
}

export default NewsletterPage
